import { gql } from '@apollo/client';

export const PAGE_QUERY_DSP_EXPENSE_REPORT = gql`
    query PageQueryDspExpenseReport(
        $filters: DspExpenseReportFilterInput
        $page: Int!
        $pageSize: Int!
    ) {
        pageQueryDspExpenseReport(filters: $filters, page: $page, pageSize: $pageSize) {
            total
            success
            message
            messageKey
            list {
                rowType
                groupKey
                rowKey
                billId
                dspId
                periodLabel
                dspFullName
                dspName
                oneSortingCode
                twoSortingCode
                threeSortingCode
                unitPrice
                driverCnt
                deliveredCnt
                deductionOnOrder
                deductionTotal
                dspOtherAdjustment
                sameAddressReduction
                settlementAmountExclNonOrder
                settlementAmountInclNonOrder
                fullPriceDeliveredCnt
                discountDeliveredCnt
                parcelPerDriver
                costPerParcel
            }
        }
    }
`;
